import moment from "moment";

/**
 * Checks if a product is currently available for ordering based on its
 * onset/deadline window.
 *
 * `deadline` and `onset` from the API are Unix timestamps for real instants
 * in UTC (standard epoch seconds). Compare them to the current instant.
 *
 * Pass `onset: null` to skip the onset check (e.g. POS only needs to
 * know if the deadline has passed, since onset is handled via badges).
 *
 * @returns true if the product is available for ordering.
 */
export function isProductAvailable({
  deadline,
  onset
}: {
  deadline: number | null;
  onset: number | null;
}): boolean {
  if (deadline === null && onset === null) {
    return true;
  }

  const nowUnix = moment().unix();

  if (onset !== null && onset > nowUnix) {
    return false;
  }

  if (deadline !== null && deadline < nowUnix) {
    return false;
  }
  return true;
}
